import { useState } from 'react';
import PropTypes from 'prop-types';

const Message = ({
  type = 'info',
  fixed = false,
  'full-width': fullWidth = false,
  inline = false,
  title,
  onClose,
  children,
}) => {
  const [active, setActive] = useState(true);

  const icons = {
    danger: 'fa-circle-xmark',
    success: 'fa-circle-check',
    info: 'fa-circle-info',
    warning: 'fa-triangle-exclamation',
  };

  return active ? (
    <div className={`br-message ${type}`} role="alert">
      <div className="icon">
        <span
          className={`fa-solid ${icons[type]} fa-lg fa-fw`}
          aria-hidden="true"
        ></span>
      </div>
      <div className="content">
        {title ? (
          <span className={`message-title ${inline ? 'pr-2' : 'mb-2'}`}>
            {title}
          </span>
        ) : null}

        {inline ? (
          <span className="message-body">{children}</span>
        ) : (
          <div className="message-body">{children}</div>
        )}
      </div>

      {fixed ? null : (
        <div className="close">
          <button
            className="br-button circle small"
            type="button"
            aria-label="Fechar"
            onClick={() => {
              setActive(false);
              if (onClose && typeof onClose === 'function') {
                onClose();
              }
            }}
          >
            <span className="fa-solid fa-xmark" aria-hidden="true"></span>
          </button>
        </div>
      )}
    </div>
  ) : null;
};

Message.propTypes = {
  title: PropTypes.string,
  type: PropTypes.oneOf(['danger', 'success', 'info', 'warning']).isRequired,
  inline: PropTypes.bool,
  'full-width': PropTypes.bool,
  fixed: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

Message.defaultTypes = {
  type: 'info',
  inline: false,
  'full-width': false,
  fixed: false,
  onClose: () => {},
};

export default Message;
